import ClassNames from "classnames";
import { FunctionComponent, RefCallback } from "react";
import headerBaseStyles from "../stylesheets/components/header-base.module.css";
import styles from "../stylesheets/components/header-layout-2.module.css";
import imageOverlayStyles from "../stylesheets/components/image-overlay.module.css";
import { CommonHeaderLayoutProps, HeaderMenuVariant } from "../types/index.js";
import { getImageModuleWithFixedAspectRatio } from "../utils/utils.js";
import HeaderActionBottomBar from "./HeaderActionBottomBar.js";
import HeaderActionLinks from "./HeaderActionLinks.js";
import Header2Mobile from "./HeaderMobile/Header2Mobile.js";
import ImagesModule from "./Modules/ImagesModule.js";
import SplitMainMenu from "./SplitMainMenu.js";

interface Props {
  intersectionTriggerRef: RefCallback<HTMLElement>;
  variant: HeaderMenuVariant;
  common: CommonHeaderLayoutProps;
}

const HeaderLayout2: FunctionComponent<Props> = ({
  intersectionTriggerRef,
  variant,
  common,
  common: {
    accommodation,
    actionLinks,
    activePagePath,
    imagesModule,
    isHomePage,
    isPreview,
    languageId,
    logo,
    favicon,
    logoSize,
    useFaviconAsLogo,
    pageId,
    queries,
    scheme,
    showSouthTyrolLogo,
  },
}) => {
  const headerLogo = favicon && useFaviconAsLogo ? favicon : logo;

  return (
    <>
      {imagesModule?.pageId && (
        <div
          className={ClassNames(
            headerBaseStyles.HeaderModule__Inner,
            headerBaseStyles["HeaderModule__Inner--wide"],
            styles[`HeaderModule__Inner--menu-position-${variant}`],
            imageOverlayStyles[
              `ImageOverlay__HeaderModule--menu-position-${variant}`
            ],
            {
              [headerBaseStyles["HeaderModule__Inner--is-home"]]: isHomePage,
              [headerBaseStyles["HeaderModule__Inner--preview"]]: isPreview,
              [headerBaseStyles["HeaderModule__Inner--full-height"]]:
                !isPreview,
            },
          )}
        >
          <SplitMainMenu
            isPreview={isPreview}
            languageId={languageId}
            pageId={pageId}
            activePagePath={activePagePath}
            scheme={scheme}
            variant={variant}
            outerWrapperRef={intersectionTriggerRef}
            showSouthTyrolLogo={showSouthTyrolLogo}
            logo={headerLogo}
            logoSize={logoSize}
          />

          <ImagesModule
            translatedModule={getImageModuleWithFixedAspectRatio(imagesModule)}
            isPreview={isPreview}
            pageId={pageId}
            queries={queries}
            isActive={false}
            isInsideHeader={true}
            isFirstOnPage={false}
            parentScheme={scheme}
            activeModuleId={undefined}
            fullHeight={!isPreview}
            className={styles.HeaderModule__ImagesModule}
          />

          {variant === "top-bottom-bars" && (
            <HeaderActionBottomBar
              accommodation={accommodation}
              actionLinks={actionLinks}
              isPreview={isPreview}
              scheme={scheme}
              languageId={languageId}
            />
          )}

          {variant === "bottom-bar" && (
            <div className={styles["HeaderModule__InnerOverlay--split-menu"]}>
              <HeaderActionLinks
                languageId={languageId}
                accommodation={accommodation}
                isPreview={isPreview}
                actionLinks={actionLinks}
              />
            </div>
          )}
        </div>
      )}

      <Header2Mobile {...common} logo={headerLogo} />
    </>
  );
};

export default HeaderLayout2;
